export const blockIconsTextformattingViewListNew = (
	<span className='material-symbols-outlined'>view_list</span>
);
